import React from 'react';
import styles from './AnimatedLogo.module.css';

/**
 * WST-Logo in zwei Animations-Varianten:
 *   - "scaffold" (default): Buchstaben zeichnen sich per stroke-dash-offset Linie fuer Linie.
 *     Fuer den initialen Seiten-Ladevorgang (bleibt unveraendert).
 *   - "builder": Echtes RTS-Gebaeude-Bauen. Buchstaben bestehen aus einzelnen Bauteilen
 *     (Strichen), die von verschiedenen Richtungen zusammenfliegen, sich zusammensetzen,
 *     halten und wieder auseinanderfliegen. Fuer Modal-Loadings.
 */

// Bauteile fuer die Builder-Variante. Jeder Buchstabe ist in einzelne Striche zerlegt.
// bx/by/br = Start-Offset (wo das Bauteil herkommt) + Rotation beim Aufbau
// dx/dy/dr = Disperse-Offset (wo es beim Abbau hinfliegt) + Rotation
const RTS_SEGMENTS = [
  // W (4 Striche)
  { d: 'M 20 30 L 36 78', delay: 0.00, bx: -22, by: 32,  br: -28, dx: -32, dy: 52, dr: -42 },
  { d: 'M 36 78 L 52 46', delay: 0.05, bx: 12,  by: 38,  br: 18,  dx: 28,  dy: 58, dr: 32 },
  { d: 'M 52 46 L 68 78', delay: 0.10, bx: -12, by: 38,  br: -18, dx: -24, dy: 58, dr: -28 },
  { d: 'M 68 78 L 84 30', delay: 0.15, bx: 22,  by: 32,  br: 28,  dx: 32,  dy: 52, dr: 42 },
  // S (5 Striche)
  { d: 'M 180 32 L 115 32', delay: 0.22, bx: 32,  by: -28, br: 22,  dx: 42,  dy: -42, dr: 38 },
  { d: 'M 115 32 L 115 55', delay: 0.27, bx: -28, by: 6,   br: -12, dx: -38, dy: 16,  dr: -22 },
  { d: 'M 115 55 L 180 55', delay: 0.32, bx: 32,  by: 0,   br: 14,  dx: 42,  dy: 12,  dr: 28 },
  { d: 'M 180 55 L 180 78', delay: 0.37, bx: 32,  by: 28,  br: 18,  dx: 42,  dy: 44,  dr: 34 },
  { d: 'M 180 78 L 115 78', delay: 0.42, bx: -28, by: 38,  br: -22, dx: -38, dy: 54,  dr: -36 },
  // T (2 Striche)
  { d: 'M 210 32 L 275 32', delay: 0.48, bx: 32, by: -28, br: 16, dx: 42, dy: -42, dr: 30 },
  { d: 'M 242 32 L 242 78', delay: 0.54, bx: 6,  by: 38,  br: -10, dx: 12, dy: 54,  dr: -18 },
];

const AnimatedLogo = ({ animated = true, variant = 'scaffold', width = 240, className = '' }) => {
  const height = Math.round(width * (110 / 295));
  const variantClass = variant === 'builder' ? styles.builder : styles.scaffold;

  // builder-Variante: 3 ganze Buchstaben (stabilere Geometrie als einzelne Strich-Bauteile)
  return (
    <svg
      viewBox="0 0 295 110"
      width={width}
      height={height}
      className={`${styles.logo} ${animated ? styles.animated : ''} ${variantClass} ${className}`}
      role="img"
      aria-label="WSTickets Logo"
    >
      <defs>
        <linearGradient id="wstGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#4a9eff" />
          <stop offset="50%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#007BFF" />
        </linearGradient>
      </defs>
      <path d="M 20 30 L 36 78 L 52 46 L 68 78 L 84 30" className={`${styles.brick} ${styles.brickW}`} pathLength="100" />
      <path d="M 180 32 L 115 32 L 115 55 L 180 55 L 180 78 L 115 78" className={`${styles.brick} ${styles.brickS}`} pathLength="100" />
      <path d="M 210 32 L 275 32 M 242 32 L 242 78" className={`${styles.brick} ${styles.brickT}`} pathLength="100" />
    </svg>
  );
};

export default AnimatedLogo;
